var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect, _rect2, _rect3, _rect4, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect5, _rect6, _rect7, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForbiddenImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 251,
    viewBox: "0 0 342 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.4619 227H274.542L251.212 240.5H78.5814C76.5362 240.5 75.8095 237.793 77.5797 236.769L94.4619 227Z",
    fill: "#F1F2F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.087 233L166.837 224L127.259 86H117.263L113.743 98.25L152.431 233H162.087Z",
    fill: "#CFD3D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.087 233L166.837 224L127.259 86H117.263M162.087 233H152.431L113.743 98.25L117.263 86M162.087 233L117.263 86",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.837 224L162.087 233L117.263 86H127.259L166.837 224Z",
    fill: "#0F2342"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4932 233L77.7432 224L117.321 86H127.317L130.837 98.25L92.1494 233H82.4932Z",
    fill: "#F1F2F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7432 224L82.4932 233H92.1494M77.7432 224L117.321 86H127.317M77.7432 224H87.7432M127.317 86L130.837 98.25L92.1494 233M127.317 86L87.7432 224M92.1494 233L87.7432 224",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M82.4932 233L77.7432 224H87.7432L127.317 86L130.837 98.25L92.1494 233H82.4932Z",
    fill: "#0F2342"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.681 203.256L159.22 208.256L162.298 219H263.809L260.728 208.256L259.212 203.256H160.681Z",
    fill: "#CFD3D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.22 208.256L160.681 203.256H259.212L260.728 208.256M159.22 208.256H260.728M159.22 208.256L162.298 219H263.809L260.728 208.256",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.22 208.256L160.681 203.256H259.212L260.728 208.256H159.22Z",
    fill: "#0F2342"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M277.681 233L282.431 224L242.853 86H232.856L229.337 98.25L268.024 233H277.681Z",
    fill: "#CFD3D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M277.681 233L282.431 224L242.853 86H232.856M277.681 233H268.024L229.337 98.25L232.856 86M277.681 233L232.856 86",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.431 224L277.681 233L232.856 86H242.853L282.431 224Z",
    fill: "#0F2342"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M198.087 233L193.337 224L232.915 86H242.911L246.431 98.25L207.743 233H198.087Z",
    fill: "#F1F2F4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M193.337 224L198.087 233H207.743M193.337 224L232.915 86H242.911M193.337 224H203.337M242.911 86L246.431 98.25L207.743 233M242.911 86L203.337 224M207.743 233L203.337 224",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M198.087 233L193.337 224H203.337L242.911 86L246.431 98.25L207.743 233H198.087Z",
    fill: "#0F2342"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M109.931 171L108.47 166L127.954 98H229.478L209.978 166L208.462 171H109.931Z",
    fill: "#FAFBFB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.47 166L109.931 171H208.462L209.978 166M108.47 166L127.954 98H229.478L209.978 166M108.47 166H209.978",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2557_17114",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 97,
    width: 123,
    height: 70
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M127.954 98L108.47 166H209.978L229.478 98H127.954Z",
    fill: "#FAFBFB",
    stroke: "#3F4F68",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2557_17114)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.0864,
    y: 92.25,
    width: 16,
    height: 130,
    transform: "rotate(-46 49.0864 92.25)",
    fill: "#FF7A00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94.1348,
    y: 92.25,
    width: 16,
    height: 130,
    transform: "rotate(-46 94.1348 92.25)",
    fill: "#FF7A00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 139.184,
    y: 92.25,
    width: 16,
    height: 130,
    transform: "rotate(-46 139.184 92.25)",
    fill: "#FF7A00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 184.232,
    y: 92.25,
    width: 16,
    height: 130,
    transform: "rotate(-46 184.232 92.25)",
    fill: "#FF7A00"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.931 171L108.47 166L127.954 98H229.478L209.978 166L208.462 171H109.931Z",
    fill: "url(#paint0_linear_2557_17114)",
    style: {
      mixBlendMode: "overlay"
    }
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M108.47 166L109.931 171H208.462L209.978 166M108.47 166L127.954 98H229.478L209.978 166M108.47 166H209.978",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M108.47 166L109.931 171H208.462L209.978 166H108.47Z",
    fill: "#0F2342"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7275 224L93.2666 219L96.3451 208.256H197.855L194.774 219L193.259 224H94.7275Z",
    fill: "#FAFBFB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2666 219L94.7275 224H193.259L194.774 219M93.2666 219H194.774M93.2666 219L96.3451 208.256H197.855L194.774 219",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M93.2666 219L94.7275 224H193.259L194.774 219H93.2666Z",
    fill: "#0F2342"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M258.258 234.984H334.836C336.817 234.984 337.593 237.554 335.943 238.65L318.131 250.484H241.552C239.572 250.484 238.796 247.914 240.445 246.819L258.258 234.984Z",
    fill: "#F1F2F4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33008 222H73.5447C75.1907 222 76.132 223.877 75.1475 225.196L68.2031 234.5H3.98851C2.34254 234.5 1.4012 232.623 2.38575 231.304L9.33008 222Z",
    fill: "#F1F2F4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M316.437 246.484H238.988C238.436 246.484 237.988 246.037 237.988 245.484V235.777C237.988 235.586 238.043 235.399 238.146 235.238L242.162 228.976C242.346 228.689 242.663 228.516 243.004 228.516H320.41C320.962 228.516 321.41 228.963 321.41 229.516V239.195C321.41 239.384 321.357 239.569 321.256 239.729L317.283 246.018C317.099 246.308 316.78 246.484 316.437 246.484Z",
    fill: "#FF7A00",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M316.988 246.484H238.988C238.436 246.484 237.988 246.037 237.988 245.484V235.484M316.988 246.484V235.484M316.988 246.484L321.256 239.729C321.357 239.569 321.41 239.384 321.41 239.195V228.516M316.988 235.484H237.988M316.988 235.484L321.41 228.516M237.988 235.484L242.162 228.976C242.346 228.689 242.663 228.516 243.004 228.516H321.41",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M237.988 246.484H316.988V235.484H237.988V246.484Z",
    fill: "#0F2342"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M321.506 239.5L316.988 246.484V235.484L321.506 228.5V239.5Z",
    fill: "#0F2342"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M311.856 231.881H247.106L270.635 154.125C270.635 154.125 273.638 152 279.447 152C285.256 152 288.26 154.125 288.26 154.125L311.856 231.881Z",
    fill: "#F1F2F4",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2557_17114",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 246,
    y: 151,
    width: 67,
    height: 82
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M311.856 231.881H247.106L270.635 154.125C270.635 154.125 273.638 152 279.447 152C285.256 152 288.26 154.125 288.26 154.125L311.856 231.881Z",
    fill: "#F1F2F4",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2557_17114)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 234.268,
    y: 223,
    width: 92.8628,
    height: 20,
    fill: "#FF7A00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 243.606,
    y: 187,
    width: 72.2744,
    height: 20,
    fill: "#FF7A00"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 247.63,
    y: 151,
    width: 64.2261,
    height: 20,
    fill: "#FF7A00"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.856 234.881H251.106L274.635 157.125C274.635 157.125 277.638 155 283.447 155C289.256 155 292.26 157.125 292.26 157.125L315.856 234.881Z",
    fill: "url(#paint1_linear_2557_17114)",
    style: {
      mixBlendMode: "overlay"
    }
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M311.856 231.881H247.106L270.635 154.125C270.635 154.125 273.638 152 279.447 152C285.256 152 288.26 154.125 288.26 154.125L311.856 231.881Z",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56 232V8L61 1H71V225L66 232H56Z",
    fill: "#F1F2F4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M56 8V232H66M56 8H65.9961M56 8L61 1H71M65.9961 8L71 1M65.9961 8L66 232M71 1V225L66 232",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M61 1L56 8H66V232L71 225V1H61Z",
    fill: "#0F2342"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14L15 18V86H107L111 82.5V14H18Z",
    fill: "#FCFDFD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18L18 14H111M15 18V86H107M15 18H107M107 86V18M107 86L111 82.5V14M111 14L107 18",
    stroke: "#3F4F68",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M18 14L15 18H107V86L111 82V14H18Z",
    fill: "#0F2342"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 52C86 65.8071 74.8071 77 61 77C47.1929 77 36 65.8071 36 52C36 38.1929 47.1929 27 61 27C74.8071 27 86 38.1929 86 52ZM72.1462 67.3888C69.0153 69.6604 65.1641 71 61 71C50.5066 71 42 62.4934 42 52C42 47.8359 43.3396 43.9847 45.6112 40.8538L72.1462 67.3888ZM76.3888 63.1461L49.8539 36.6112C52.9848 34.3395 56.836 33 61 33C71.4934 33 80 41.5066 80 52C80 56.164 78.6605 60.0152 76.3888 63.1461Z",
    fill: "#FF7A00"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 52C86 65.8071 74.8071 77 61 77C47.1929 77 36 65.8071 36 52C36 38.1929 47.1929 27 61 27C74.8071 27 86 38.1929 86 52ZM72.1462 67.3888C69.0153 69.6604 65.1641 71 61 71C50.5066 71 42 62.4934 42 52C42 47.8359 43.3396 43.9847 45.6112 40.8538L72.1462 67.3888ZM76.3888 63.1461L49.8539 36.6112C52.9848 34.3395 56.836 33 61 33C71.4934 33 80 41.5066 80 52C80 56.164 78.6605 60.0152 76.3888 63.1461Z",
    fill: "url(#paint2_linear_2557_17114)",
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2557_17114",
    x1: 127.881,
    y1: 98,
    x2: 210.381,
    y2: 165.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2557_17114",
    x1: 261.493,
    y1: 155,
    x2: 325.144,
    y2: 180.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2557_17114",
    x1: 44.0205,
    y1: 27,
    x2: 89.8502,
    y2: 49.7045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbiddenImage);
export default __webpack_public_path__ + "static/media/forbidden-image.8269bf104a6bcea9a7c2ff385dba1797.svg";
export { ForwardRef as ReactComponent };